import React, { FunctionComponent } from 'react';
import { Box, Text, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { DATA_HOOKS } from '../../../dataHooks';
import searchBarScss from '../index.module.scss';
import { RenderHTML } from '../../RenderHTML';
import css from './index.module.scss';

/**
 * @deprecated use `components/SearchBar/EmptySearchResults/index.tsx` instead
 */
export const DeprecatedEmptySearchResults: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Box
      align="center"
      direction="vertical"
      className={css.emptySearch}
      dataHook={DATA_HOOKS.EMPTY_SEARCH_RESULTS}
      gap="6px"
    >
      <Box margin="auto" direction="vertical" align="center">
        <Heading
          className={`${css.headerMessage} ${searchBarScss.headerMessageEmptySearch}`}
          size="large"
        >
          <RenderHTML
            dataHook={DATA_HOOKS.EMPTY_SEARCH_RESULTS_TEXT}
            html={t('searchbar.empty.result.message')}
          />
        </Heading>
      </Box>
      <Text
        className={`${css.footerMessage} ${searchBarScss.footerMessageEmptySearch}`}
        weight="thin"
      >
        {t('searchbar.empty.result.try.again')}
      </Text>
    </Box>
  );
};
